import { useMutation } from 'react-query';
import usePlanStore from 'store/planStore';
import { Countries } from 'shared/enums';
import moment from 'moment';
import {
  getEstimatedTVBudget,
  GRP,
  GRPCopy,
} from '../../../../../../../../api/services/mediaPlanning/offline/calculateBudget';
import useCalculateOneReach from '../../../hooks/useCalculateOneReach';
import { useError } from '../../../../../common/Errors/ErrorContext/ErrorContext';

const useEstimatedTVBudget = () => {
  const {
    countryForms,
    selectedCountry,
    selectedCountryISOCode,
    updateCalculatedTVBudget,
    saveCountryFormState,
  } = usePlanStore();

  const { showError } = useError();

  const {
    mutate: calculateBudget,
    data: response,
    isLoading,
    isError,
  } = useMutation(
    async () => {
      const latestState = usePlanStore.getState();
      const offline = latestState.countryForms[selectedCountry!]?.offline;
      if (!offline?.tv?.grpTable) {
        return null;
      }
      let copies:
        | {
            name: string;
            copyLength?: number;
            advertisers?: string[];
            advertisersLength?: number;
          }[]
        | undefined = [];

      copies = offline?.tv?.copyForm.map((form) => {
        return {
          name: `${form.copyLength}s${
            form.additionalAdvertisers ? `_${form.additionalAdvertisers}` : ''
          }${
            form.advertisers?.length
              ? `_${form.advertisers
                  .map((advertiser) => `${advertiser.id}`)
                  .join('-')}`
              : ''
          }`,
          id: form.id,
          copyLength: form.copyLength
            ? (+form.copyLength as unknown as number)
            : 0,
          advertisers: form.advertisers
            ? form.advertisers.map((advertiser) => advertiser.id)
            : [],
          advertisersLength: form.additionalAdvertisers
            ? +form.additionalAdvertisers
            : 0,
        };
      });

      let grps: GRP[] | undefined = [];

      grps = offline?.tv?.grpTable?.weeks.map((week) => {
        const parsedDate = moment(week.startingDate, 'DD-MM-YYYY');
        return {
          year: parsedDate.year(),
          month: parsedDate.month() + 1,
          weekNumber: week.weekNumber,
          copies: week.copy.value.map((value) => {
            return {
              name: value.name,
              id: value.id,
              grp: value.value,
            };
          }),
        };
      });

      return getEstimatedTVBudget({
        body: {
          copies,
          countryISO: latestState.selectedCountryISOCode as Countries,
          grps,
          targetGroup: offline?.tv?.targetGroup ?? '',
        },
      });
    },
    {
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message || error.message || 'Unknown error';
        showError(errorMessage);
      },
      onSuccess: async (successResponse) => {
        if (successResponse?.data) {
          updateCalculatedTVBudget(selectedCountry!, successResponse.data);
          const tvBudget = {
            ...successResponse.data,
          };

          updateCalculatedTVBudget(selectedCountry!, tvBudget);
        }
      },
    }
  );

  return {
    calculateBudget,
    data: response?.data,
    isLoading,
    isError,
  };
};

export default useEstimatedTVBudget;
